<form [formGroup]="parentFormGroup">
  <h3 class="sub-section-title">Apps</h3>
  @if (!showAppSelector) {
    <button type="button" class="show-app-selector" mat-button (click)="showAppSelector = true">
      <mat-icon>add</mat-icon> Add App
    </button>
  }
  <div class="container-wrap">
    @if (showAppSelector) {
      <div class="row-wrap half-width">
        <app-selector #appSelector [(selectedApp)]="newApp" class="item" [placeholderText]="'Select new App'"></app-selector>
        <div [matTooltip]="newApp && !canAddNewApp ? 'App is already added' : 'Please select app'"
          [matTooltipDisabled]="canAddNewApp" matTooltipPosition="right">
          <button type="button" class="add-app-button" mat-button [disabled]="!canAddNewApp"
            (click)="addNewAppToSectionApps()">{{caption}}</button>
        </div>
      </div>
    }
    <div [formArrayName]="controlName" cdkDropList (cdkDropListDropped)="drop($event)">
      @for (appId of appList; track $index; let i = $index) {
        <div cdkDrag>
          <div class="app">
            <div class="icons-wrap">
              <span class="drag-handle" cdkDragHandle>
                <mat-icon>drag_indicator</mat-icon>
              </span>
            </div>
            <div class="row-wrap">
              <div class="item app-name">{{getAppName(appId)}}
                <span class="app-id">(ID: {{appId}})</span>
              </div>
              <div class="controls">
                <button type="button" mat-icon-button (click)="moveAppDown(i)" [disabled]="i === (appList.length - 1)">
                  <mat-icon>arrow_downward</mat-icon>
                </button>
                <button type="button" mat-icon-button (click)="moveAppUp(i)" [disabled]="i === 0">
                  <mat-icon>arrow_upward</mat-icon>
                </button>
                <button type="button" mat-raised-button color="primary" (click)="deleteApp(i)">
                  <mat-icon>delete_outline</mat-icon> Delete app
                </button>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    @if (!appList?.length) {
      <div class="note">There are no predefined Apps for this section.</div>
    }
  </div>
</form>
